import { useQuery } from '@tanstack/react-query';

import { getDateTimeFormat } from '@helpers/getDateTimeFormat';
import { getUserAccessAndRole } from '@helpers/getUserAccessAndRole';

import { apiClient } from '@services/apiClient';

import { selectAppPersistRefreshInterval } from '@store/useAppStorePersist';

export const userProfileKey = () => ['userProfile'];
export const userProfileFn = () => apiClient.get(`${APP_SSO_URL}api/user/profile-v2`);

const useUserProfileSelect = ({ data }) => {
  const { userAccess, userRole } = getUserAccessAndRole(data?.permissions, data?.customer?.system_version);

  return {
    user: { ...data?.user, last_seen: !!data?.last_seen },
    userAccess: userAccess,
    role: userRole,
    permissions: data?.permissions,
    customer: data?.customer,
    dateFormat: getDateTimeFormat(data.user.personal_settings?.datetime_format),
  };
};

export const useUserProfileQuery = () => {
  const refreshInterval = selectAppPersistRefreshInterval();

  return useQuery({
    queryKey: userProfileKey(),
    queryFn: userProfileFn,
    refetchInterval: refreshInterval,
    select: useUserProfileSelect,
  });
};
